import React from 'react';

const AMENITIES = [
  'Parking', 'Garden', 'Internet/WiFi', 'Furnished',
  'Pet friendly', 'Wheelchair accessible', 'Close to public transport',
  'Close to shops', 'Air conditioning', 'Heating', 'Laundry',
  'Dishwasher', 'Swimming pool', 'Balcony/deck', 'Lock-up garage',
];

const PropertyOptionalFields = ({ formData, handleInputChange, setFormData }) => (
  <>
    <div className="form-section">
      <h2>Property Details <span className="optional-badge">Optional</span></h2>
      <div className="form-row">
        <div className="form-group">
          <label className="input-label">Property Type</label>
          <select name="property_type" value={formData.property_type} onChange={handleInputChange} className="input-field">
            <option value="house">House</option>
            <option value="apartment">Apartment</option>
            <option value="townhouse">Townhouse</option>
            <option value="unit">Unit</option>
            <option value="villa">Villa</option>
            <option value="granny_flat">Granny Flat</option>
          </select>
        </div>
        <div className="form-group">
          <label className="input-label">Postcode</label>
          <input type="text" name="postcode" value={formData.postcode} onChange={handleInputChange} className="input-field" placeholder="e.g. 2204" />
        </div>
      </div>
      <div className="form-group">
        <label className="input-label">Street Address</label>
        <input type="text" name="address" value={formData.address} onChange={handleInputChange} className="input-field" placeholder="Leave blank if TBA" />
      </div>
    </div>

    <div className="form-section">
      <h2>Accommodation Details <span className="optional-badge">Optional</span></h2>
      <div className="form-row">
        <div className="form-group">
          <label className="input-label">Total Bedrooms</label>
          <input type="number" name="total_bedrooms" value={formData.total_bedrooms} onChange={handleInputChange} className="input-field" min="1" placeholder="e.g. 4" />
        </div>
        <div className="form-group">
          <label className="input-label">Available Bedrooms</label>
          <input type="number" name="available_bedrooms" value={formData.available_bedrooms} onChange={handleInputChange} className="input-field" min="1" placeholder="e.g. 2" />
        </div>
        <div className="form-group">
          <label className="input-label">Total Bathrooms</label>
          <input type="number" name="total_bathrooms" value={formData.total_bathrooms} onChange={handleInputChange} className="input-field" min="1" placeholder="e.g. 2" />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="input-label">Bond Required ($)</label>
          <input type="number" name="bond_required" value={formData.bond_required} onChange={handleInputChange} className="input-field" step="0.01" placeholder="Leave blank if TBA" />
        </div>
        <div className="form-group">
          <label className="input-label">Available From</label>
          <input type="date" name="available_from" value={formData.available_from} onChange={handleInputChange} className="input-field" />
        </div>
        <div className="form-group">
          <label className="input-label">Lease Term</label>
          <input type="text" name="lease_term" value={formData.lease_term} onChange={handleInputChange} className="input-field" placeholder="e.g. 6 months minimum" />
        </div>
      </div>
    </div>

    <div className="form-section">
      <h2>House Policies <span className="optional-badge">Optional</span></h2>
      <div className="form-row">
        <div className="form-group">
          <label className="input-label">Pet Policy</label>
          <input type="text" name="pet_policy" value={formData.pet_policy} onChange={handleInputChange} className="input-field" placeholder="e.g. Cats OK, No dogs" />
        </div>
        <div className="form-group">
          <label className="input-label">Smoking Policy</label>
          <input type="text" name="smoking_policy" value={formData.smoking_policy} onChange={handleInputChange} className="input-field" placeholder="e.g. Outside only" />
        </div>
      </div>
      <div className="form-group">
        <label className="input-label">House Rules</label>
        <textarea name="house_rules" value={formData.house_rules} onChange={handleInputChange} className="input-field" rows="3" placeholder="Any specific house rules..." />
      </div>
    </div>

    <div className="form-section">
      <h2>Amenities <span className="optional-badge">Optional</span></h2>
      <div className="checkbox-grid two-col">
        {AMENITIES.map(amenity => (
          <label key={amenity} className="checkbox-label">
            <input type="checkbox" name="amenities[]" value={amenity} checked={formData.amenities.includes(amenity)} onChange={handleInputChange} />
            <span>{amenity}</span>
          </label>
        ))}
      </div>
    </div>

    <div className="form-section">
      <h2>Property Features <span className="optional-badge">Optional</span></h2>
      <div className="form-grid">
        <div className="form-group">
          <label className="input-label">Storeys</label>
          <select name="storeys" value={formData.storeys} onChange={handleInputChange} className="input-field" data-testid="storeys-select">
            <option value="1">1 Storey</option><option value="2">2 Storey</option><option value="3">3+ Storey</option>
          </select>
        </div>
        <div className="form-group">
          <label className="input-label">Living Areas</label>
          <input type="number" name="num_living_areas" value={formData.num_living_areas} onChange={handleInputChange} className="input-field" placeholder="e.g., 2" min="0" data-testid="living-areas-input" />
        </div>
        <div className="form-group">
          <label className="input-label">Parking Spaces</label>
          <input type="number" name="parking_spaces" value={formData.parking_spaces} onChange={handleInputChange} className="input-field" placeholder="e.g., 2" min="0" data-testid="parking-spaces-input" />
        </div>
        <div className="form-group">
          <label className="input-label">Walkability Score (0-100)</label>
          <input type="number" name="walkability_score" value={formData.walkability_score} onChange={handleInputChange} className="input-field" placeholder="e.g., 75" min="0" max="100" data-testid="walkability-input" />
        </div>
        <div className="form-group">
          <label className="input-label">Furnished</label>
          <select name="furnished" value={formData.furnished} onChange={handleInputChange} className="input-field" data-testid="furnished-select">
            <option value="">Not specified</option>
            <option value="furnished">Furnished</option>
            <option value="unfurnished">Unfurnished</option>
            <option value="partial">Partially Furnished</option>
          </select>
        </div>
      </div>
      <div className="amenities-grid" style={{ marginTop: '16px' }}>
        {[
          { key: 'has_pool', label: 'Swimming Pool' },
          { key: 'has_aircon', label: 'Air Conditioning' },
          { key: 'has_parking', label: 'Off-street Parking' },
          { key: 'has_outdoor_area', label: 'Outdoor Area / Deck / Patio' },
          { key: 'pet_friendly', label: 'Pet Friendly' },
        ].map(({ key, label }) => (
          <label key={key} className="checkbox-label">
            <input type="checkbox" checked={formData[key]} onChange={(e) => setFormData(prev => ({ ...prev, [key]: e.target.checked }))} data-testid={`feature-${key}`} />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </div>
  </>
);

export default PropertyOptionalFields;
